import store from '~/store';


export const userDispatcher = () => {
  const {account} = store.getState();
  if (account && account.userInfo && account.userInfo.data) {
    if (account.accountLevel > account.free) {
      return '/my-account';
    }
    return '/free-account';
  }
}


// WEBPACK FOOTER //
// ./src/misc/userAccount.js